<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Charity Points</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <b>Charity Points</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">

        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">

            <h4 class="card-title mb-3">Charity Point Preset</h4>
              <router-link :to="{name: 'charityPoint-edit'}" type="button" class="btn btn-primary btn-rounded" style="margin-bottom: 20px; width: 10%;">
                Edit
              </router-link>

              <!-- Points Table -->
              <div class="table-responsive">
                <table id="charity_point_tbl" class="display table table-striped table-bordered" style="width:100%; text-align: center;">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>BND</th>
                      <th>Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(rate, index) in rates" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ rate.price }}</td>
                      <td>{{ rate.point }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "charityPoint-view",

  data() {
    return {
        rates: []
    };
  },

  methods: {
    loadRate() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/charity_point", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.rates = res.data;

          })
          .then(function() {
            $("#charity_point_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadRate();
    },

    redirect(){
        return "/setting/point/details"
    },

    destroyDatatable() {
        $("#charity_point_tbl").DataTable().destroy();
    }
  },

  mounted() {
        this.loadData()
  }
};
</script>
